import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Backdrop,
  CircularProgress,
  Tooltip,
  TableSortLabel,
  Box,
} from "@mui/material";
import { useSelector } from "react-redux";
import CorePagination from "../CorePagination/CorePagination";
import { t } from "i18next";

const CoreTable = ({
  rows, // ARRAY degli elementi della tabella
  columns, // ARRAY delle intestazioni delle colonne della tabella
  button, // BOOLEANO se vuoi bottoni nella tabella
  actions, // ARRAY di bottoni della tabella
  isLoading,
  page = false,
  setPage,
  totalPages,
  orderDirection,
  setOrderDirection,
  valueToOrderBy,
  setValueToOrderBy,
  idsSort,
  collapse,
  openRows,
}) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  const handleRequestSort = (property) => {
    const isAscending = valueToOrderBy === property && orderDirection === "asc";
    setValueToOrderBy(property);
    setOrderDirection(isAscending ? "desc" : "asc");
  };

  return (
    <div className="w-full p-4">
      <TableContainer sx={{ position: "relative" }}>
        <Backdrop
          className="backdrop-animation"
          sx={{ position: "absolute", zIndex: 1 }}
          open={isLoading}
        >
          <CircularProgress style={{ color: colorPrimary }} />
        </Backdrop>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size="medium"
        >
          <TableHead>
            <TableRow>
              {columns.map((header, index) => (
                <TableCell key={index} className={"min-w-48"}>
                  <TableSortLabel
                    disabled={idsSort ? idsSort.includes(header.id) : true}
                    active={idsSort ? valueToOrderBy === header.id : false}
                    direction={orderDirection}
                    onClick={() =>
                      handleRequestSort(idsSort ? header.id : header)
                    }
                  >
                    {idsSort ? header.label : header}
                  </TableSortLabel>
                </TableCell>
              ))}
              {button && <TableCell>{t("Actions")}</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <>
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  className="hover:shadow-md"
                  style={row.style}
                  key={index}
                >
                  {columns.map((header, index) => (
                    <TableCell key={index} sx={{ height: "73px" }}>
                      {idsSort ? row[header.label] : row[header]}
                    </TableCell>
                  ))}
                  {button && (
                    <TableCell className="min-w-48">
                      {actions.map((action, index) => (
                        <Tooltip title={action.tooltip} key={index}>
                          <IconButton
                            className="w-10 h-10"
                            onClick={() => action.onClick(row)}
                          >
                            {action.icon}
                          </IconButton>
                        </Tooltip>
                      ))}
                    </TableCell>
                  )}
                </TableRow>
                {collapse && openRows[row.id] && (
                  <TableRow>
                    <TableCell
                      className="p-0"
                      colSpan={columns.length + (button ? 1 : 0)}
                      sx={{ paddingBottom: 0, paddingTop: 0 }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          padding: "0px",
                          boxSizing: "border-box",
                        }}
                      >
                        <Table size="small" sx={{ width: "100%" }}>
                          <TableBody className="bg-zinc-50">
                            {row.collapse.map((el, idx) => (
                              <TableRow key={idx}>
                                {columns.map((header, index) => (
                                  <TableCell key={index}>
                                    {el[header]}
                                  </TableCell>
                                ))}
                              </TableRow>
                            ))}
                            {row.collapse.length === 0 && (
                              <div className="h-16 w-full flex justify-center items-center text-gray">
                                {t("NotElement")}
                              </div>
                            )}
                          </TableBody>
                        </Table>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
              </>
            ))}
          </TableBody>
        </Table>
        {rows.length === 0 && (
          <div className="h-16 w-full flex justify-center items-center tex-gray">
            Nessun elemento
          </div>
        )}
        <Divider />
        {page && (
          <div className="w-full flex justify-center">
            <CorePagination
              page={page}
              setPage={setPage}
              totalPages={totalPages}
            />
          </div>
        )}
      </TableContainer>
    </div>
  );
};

export default CoreTable;
